import api from '../config/Api';

const endpoint = 'v1/attribute-iplusd-achievable';

export default {

  getAttributeIDAchievableParams( attributeId, params ) {
    return api.get( `${endpoint}/${attributeId}`, params );
  },

  updateAttributeIDAchievableParam( id, data ) {
    return api.put( `${endpoint}/${id}`, data );
  },
};
